import { render, staticRenderFns } from "./BirthdayHoliday.vue?vue&type=template&id=1cbf55f8&scoped=true&"
import script from "./BirthdayHoliday.vue?vue&type=script&lang=js&"
export * from "./BirthdayHoliday.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayHoliday.vue?vue&type=style&index=0&id=1cbf55f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf55f8",
  null
  
)

export default component.exports